import PropTypes from 'prop-types';
import React from 'react';
import { Button, CloseButton, Modal, Spinner } from 'react-bootstrap';

const ModalCombinarClientes = ({
    showModalCombinarClientes,
    setShowModalCombinarClientes,
    customerdetails,
    habilitarBtnCombinar,
    combinarClientes
}) => {
    return (
        <Modal
            show={showModalCombinarClientes}
            onHide={() => setShowModalCombinarClientes(false)}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">Combinar clientes</Modal.Title>
                <CloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => setShowModalCombinarClientes(false)}
                />
            </Modal.Header>
            <Modal.Body>
                <h5>
                    Al combinar el cliente todas sus licencias, ordenes y leads pasaran a ser del cliente{' '}
                    <b>{customerdetails.vRazonSocial}</b>
                </h5>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={() => setShowModalCombinarClientes(false)}>
                    Cancelar
                </Button>

                {habilitarBtnCombinar ? (
                    <Button variant='success' onClick={() => combinarClientes()}>
                        Combinar
                    </Button>
                ) : (
                    <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

ModalCombinarClientes.propTypes = {
    showModalCombinarClientes: PropTypes.bool.isRequired,
    setShowModalCombinarClientes: PropTypes.func.isRequired,
    customerdetails: PropTypes.shape({
        vRazonSocial: PropTypes.string
    }).isRequired,
    habilitarBtnCombinar: PropTypes.bool.isRequired,
    combinarClientes: PropTypes.func.isRequired
};

export default ModalCombinarClientes;
